function fireEvent(action) {
	const e = document.createEvent('CustomEvent');
	e.initCustomEvent('acom-track-event', true, true, { action });
	if (action === 'sign in : success') {
		e.initCustomEvent('acom-track-mixpanel', true, true, { action });
	}
	parent.dispatchEvent(e); // The iframe doesn't have the tracking code so we need to dispatch this to the parent.
}

export default fireEvent;
